export const Service = () => {
  return (
    <>
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title text-center text-warning text-uppercase">
              Our Services
            </h6>
            <h1 className="mb-5">
              Explore Our{" "}
              <span className="text-warning text-uppercase">Services</span>
            </h1>
          </div>
          
          <div className="row g-4">
            
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
              <a className="service-item rounded" href="/">
                <div className="service-icon bg-transparent border rounded p-1">
                  <div className="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                    <i className="fa fa-hotel fa-2x text-warning" />
                  </div>
                </div>
                <h5 className="mb-3 text-dark fw-bold">Rooms &amp; Appartment</h5>
                <p className="text-muted fw-normal mb-0">
                  Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed
                  diam stet diam sed stet lorem.
                </p>
              </a>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.2s">
              <a className="service-item rounded" href="/">
                <div className="service-icon bg-transparent border rounded p-1">
                  <div className="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                    <i className="fa fa-utensils fa-2x text-warning" />
                  </div>
                </div>
                <h5 className="mb-3 text-dark fw-bold">Food &amp; Restaurant</h5>
                <p className="text-muted fw-normal mb-0">
                  Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed
                  diam stet diam sed stet lorem.
                </p>
              </a>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
              <a className="service-item rounded" href="/">
                <div className="service-icon bg-transparent border rounded p-1">
                  <div className="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                    <i className="fa fa-spa fa-2x text-warning" />
                  </div>
                </div>
                <h5 className="mb-3 text-dark fw-bold">Spa &amp; Fitness</h5>
                <p className="text-muted fw-normal mb-0">
                  Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed
                  diam stet diam sed stet lorem.
                </p>
              </a>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.4s">
              <a className="service-item rounded" href="/">
                <div className="service-icon bg-transparent border rounded p-1">
                  <div className="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                    <i className="fa fa-swimmer fa-2x text-warning" />
                  </div>
                </div>
                <h5 className="mb-3 text-dark fw-bold">Sports &amp; Gaming</h5>
                <p className="text-muted fw-normal mb-0">
                  Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed
                  diam stet diam sed stet lorem.
                </p>
              </a>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
              <a className="service-item rounded" href="/">
                <div className="service-icon bg-transparent border rounded p-1">
                  <div className="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                    <i className="fa fa-glass-cheers fa-2x text-warning" />
                  </div>
                </div>
                <h5 className="mb-3 text-dark fw-bold">Event &amp; Party</h5>
                <p className="text-muted fw-normal mb-0">
                  Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed
                  diam stet diam sed stet lorem.
                </p>
              </a>
            </div>
            <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.6s">
              <a className="service-item rounded" href="/">
                <div className="service-icon bg-transparent border rounded p-1">
                  <div className="w-100 h-100 border rounded d-flex align-items-center justify-content-center">
                    <i className="fa fa-dumbbell fa-2x text-warning" />
                  </div>
                </div>
                <h5 className="mb-3 text-dark fw-bold">GYM &amp; Yoga</h5>
                <p className="text-muted fw-normal mb-0">
                  Erat ipsum justo amet duo et elitr dolor, est duo duo eos lorem sed
                  diam stet diam sed stet lorem.
                </p>
              </a>
            </div>
          </div>
          </div>
        </div>


        
      

      <div
        className="container-xxl testimonial my-5 py-5 bg-dark wow zoomIn"
        data-wow-delay="0.1s"
      >
        <div className="container">
          <div className="owl-carousel testimonial-carousel py-5">
            <div className="testimonial-item position-relative bg-white rounded overflow-hidden">
              <p>
                Tempor stet labore dolor clita stet diam amet ipsum dolor duo ipsum
                rebum stet dolor amet diam stet. Est stet ea lorem amet est kasd kasd
                et erat magna eos
              </p>
              <div className="d-flex align-items-center">
                <img alt="/"
                  className="img-fluid flex-shrink-0 rounded"
                  src="/assets/img/testimonial-1.jpg"
                  style={{ width: 45, height: 45 }}
                />
                <div className="ps-3">
                  <h6 className="fw-bold mb-1">Client Name</h6>
                  <small>Profession</small>
                </div>
              </div>
              <i className="fa fa-quote-right fa-3x text-warning position-absolute end-0 bottom-0 me-4 mb-n1" />
            </div>
            <div className="testimonial-item position-relative bg-white rounded overflow-hidden">
              <p>
                Tempor stet labore dolor clita stet diam amet ipsum dolor duo ipsum
                rebum stet dolor amet diam stet. Est stet ea lorem amet est kasd kasd
                et erat magna eos
              </p>
              <div className="d-flex align-items-center">
                <img alt="/"
                  className="img-fluid flex-shrink-0 rounded"
                  src="/assets/img/testimonial-2.jpg"
                  style={{ width: 45, height: 45 }}
                />
                <div className="ps-3">
                  <h6 className="fw-bold mb-1">Client Name</h6>
                  <small>Profession</small>
                </div>
              </div>
              <i className="fa fa-quote-right fa-3x text-warning position-absolute end-0 bottom-0 me-4 mb-n1" />
            </div>
            <div className="testimonial-item position-relative bg-white rounded overflow-hidden">
              <p>
                Tempor stet labore dolor clita stet diam amet ipsum dolor duo ipsum
                rebum stet dolor amet diam stet. Est stet ea lorem amet est kasd kasd
                et erat magna eos
              </p>
              <div className="d-flex align-items-center">
                <img alt="/"
                  className="img-fluid flex-shrink-0 rounded"
                  src="/assets/img/testimonial-3.jpg"
                  style={{ width: 45, height: 45 }}
                />
                <div className="ps-3">
                  <h6 className="fw-bold mb-1">Client Name</h6>
                  <small>Profession</small>
                </div>
              </div>
              <i className="fa fa-quote-right fa-3x text-warning position-absolute end-0 bottom-0 me-4 mb-n1" />
            </div>
          </div>
        </div>
      </div>


    </>
  )
}
